module.exports = __webpack_public_path__ + "img/p13.0245bc2d.png";